module.exports = __webpack_public_path__ + "img/info_top.a9688d73.svg";